import RouteTemplate from 'ember-route-template';

import { pageTitle } from 'ember-page-title';

import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default RouteTemplate(<template>
  {{pageTitle "Announcement"}}

  {{#if @model.announcement.image.url}}
    <span class="c-image-callout">
      <img
        src={{@model.announcement.image.url}}
        alt={{@model.announcement.image.alt}}
      >
      <br>
      <small>{{@model.announcement.image.alt}}</small>
    </span>
  {{/if}}

  <h3 class="c-page-title qa-page-title qa-announcement-title">
    {{~@model.announcement.title~}}
  </h3>
  <div class="c-html-content">
    {{~trustedHtml @model.announcement.bodyProcessed~}}
  </div>

  {{outlet}}
</template>);
